class MegaNav extends HTMLElement {
  constructor() {
    super();
  }

  show(event) {
    this.classList.add('opened');
  }

  hide(event) {
    this.classList.remove('opened');
  }
}

customElements.define('mega-nav', MegaNav);

class MegaNavMenu extends MegaNav {
  constructor() {
    super();
    this.header = document.getElementById('MainHeader');
    this.headerStickyBehavior = this.header.getAttribute('data-sticky-behavior');

    this.shortlinksWrapper = document.querySelector('[data-meganav-menu-shortlinks]');
    this.firstLevelItems = document.querySelectorAll('[data-meganav-menu-shortlinks] .header-shortlink');
    this.secondLevelItems = this.querySelectorAll('.megamenu-submenu__item');
    this.megaNavTargets = [this.shortlinksWrapper, this];

    this.mouseInside = false;
    this.openTimeout = null; // New property for tracking the timeout
    this.setStickyBehavior();
    this.setupEventListeners();
  }

  setStickyBehavior() {
    if (['scroll', 'fixed'].includes(this.headerStickyBehavior)) {
      this.parentElement.classList.add('sticky');
    }
  }

  setupEventListeners() {
    this.megaNavTargets.forEach(target => {
      target.addEventListener('mouseenter', () => {
        this.mouseInside = true;
      });

      target.addEventListener('mouseleave', () => {
        this.mouseInside = false;
        setTimeout(() => this.checkMouseLeave(), 100);
      });
    });

    this.firstLevelItems.forEach(firstLevelItem => {
      firstLevelItem.addEventListener('mouseenter', this.handleFirstLevelItemHover.bind(this));
      firstLevelItem.addEventListener('mouseleave', this.clearOpenTimeout.bind(this)); // Clear timeout on mouse leave
    });

    this.secondLevelItems.forEach(secondLevelItem => {
      secondLevelItem.addEventListener('mouseenter', this.handleSecondLevelItem.bind(this));
    });
  }

  checkMouseLeave() {
    if (!this.mouseInside) {
      this.reset();
      this.hide();
    }
  }

  handleFirstLevelItemHover(event) {
    this.clearOpenTimeout();

    this.openTimeout = setTimeout(() => {
      const target = event.currentTarget || event.target;
      const currentMenuGroup = target.getAttribute('data-meganav-menu-group');

      [
        ...this.querySelectorAll(`[data-meganav-menu-group]`),
        ...this.querySelectorAll(`[data-meganav-menu-parent-group]`),
        ...this.firstLevelItems,
      ].forEach(element => {
        element.classList.remove('active');
      });

      target.classList.add('active');

      if (!currentMenuGroup) {
        this.hide();

        return;
      }

      this.header.classList.add('megamenu-active');
      this.querySelector(`[data-meganav-menu-group="${currentMenuGroup}"]`).classList.add('active');
      this.show();
    }, 150);
  }

  clearOpenTimeout() {
    if (this.openTimeout) {
      clearTimeout(this.openTimeout);
      this.openTimeout = null;
    }
  }

  handleSecondLevelItem(event) {
    const currentMenuGroup = event.currentTarget.getAttribute('data-meganav-menu-group');

    if (!currentMenuGroup) {
      return;
    }

    [
      ...this.querySelectorAll(`[data-meganav-menu-parent-group]`),
      ...this.querySelectorAll(`.megamenu-submenu__item.active`),
    ].forEach(element => {
      element.classList.remove('active');
    });

    if (event.type === 'mouseenter') {
      event.currentTarget.classList.add('active');
      this.querySelector(`[data-meganav-menu-parent-group="${currentMenuGroup}"]`)?.classList.add('active');
    }
  }

  reset() {
    [
      ...this.querySelectorAll(`[data-meganav-menu-group]`),
      ...this.querySelectorAll(`[data-meganav-menu-parent-group]`),
      ...this.firstLevelItems,
    ].forEach(element => {
      element.classList.remove('active');
    });

    this.header.classList.remove('megamenu-active');
  }
}

customElements.define('mega-nav-menu', MegaNavMenu);
